module.exports = __webpack_public_path__ + "static/media/IMG_2683.5f479348.JPG";